import React = require("react");
import {Loader} from "./Loader";
import "./LoaderTab.scss";

/**
 * Tab to show in the functions panel when waiting for the data.
 */
export const LoaderTab: React.SFC<{}> = () => {
    return (
        <div className={"loader-tab"}>
            <Loader/>
        </div>
    );
};
